/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUpcomingToursQueryVariables = Types.Exact<{
  input: Types.GetUpcomingConcertsInput;
}>;


export type GetUpcomingToursQuery = { __typename: 'Query', getUpcomingConcerts: { __typename: 'GetUpcomingConcertsResponse', concerts: Array<{ __typename: 'ConcertArtist', artist: { __typename: 'Artist', id: string | null, name: string | null, facebook_id: string | null, spotify_id: string | null, label: { __typename: 'Label', id: string, name: string, alias: string } | null } | null, concert: { __typename: 'Concert', id: string, cityName: string, countryName: string, venue: string, date: string, attendees: string, country_id: string, managerStatus: string, stateName: string, tourName: string, dateStatus: string } | null }> } };


export const GetUpcomingToursDocument = gql`
    query GetUpcomingTours($input: GetUpcomingConcertsInput!) {
  getUpcomingConcerts(input: $input) {
    concerts {
      artist {
        id
        name
        facebook_id
        spotify_id
        label {
          id
          name
          alias
        }
      }
      concert {
        id
        cityName
        countryName
        venue
        date
        attendees
        country_id
        managerStatus
        stateName
        tourName
        dateStatus
      }
    }
  }
}
    `;

/**
 * __useGetUpcomingToursQuery__
 *
 * To run a query within a React component, call `useGetUpcomingToursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingToursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingToursQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUpcomingToursQuery(baseOptions: Apollo.QueryHookOptions<GetUpcomingToursQuery, GetUpcomingToursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpcomingToursQuery, GetUpcomingToursQueryVariables>(GetUpcomingToursDocument, options);
      }
export function useGetUpcomingToursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpcomingToursQuery, GetUpcomingToursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpcomingToursQuery, GetUpcomingToursQueryVariables>(GetUpcomingToursDocument, options);
        }
export type GetUpcomingToursQueryHookResult = ReturnType<typeof useGetUpcomingToursQuery>;
export type GetUpcomingToursLazyQueryHookResult = ReturnType<typeof useGetUpcomingToursLazyQuery>;